/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateStudentRequest,
  GetStudentResponse,
  PaginatedResultOfGetStudentResponse,
  Result,
  ResultOfCreateStudentResponse,
  SearchQueryRequest,
  UpdateStudentRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateStudentRequestFromJSON,
    CreateStudentRequestToJSON,
    GetStudentResponseFromJSON,
    GetStudentResponseToJSON,
    PaginatedResultOfGetStudentResponseFromJSON,
    PaginatedResultOfGetStudentResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateStudentResponseFromJSON,
    ResultOfCreateStudentResponseToJSON,
    SearchQueryRequestFromJSON,
    SearchQueryRequestToJSON,
    UpdateStudentRequestFromJSON,
    UpdateStudentRequestToJSON,
} from '../models/index';

export interface ApiStudentsIdDeactivatePutRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiStudentsIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiStudentsPostRequest {
    createStudentRequest: CreateStudentRequest;
    xTenantID?: number;
}

export interface ApiStudentsPutRequest {
    updateStudentRequest: UpdateStudentRequest;
    xTenantID?: number;
}

export interface ApiStudentsScrollGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiStudentsSearchPostRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
    searchQueryRequest?: SearchQueryRequest;
}

export interface GetStudentByIdRequest {
    id: number;
    xTenantID?: number;
}

/**
 * 
 */
export class StudentsApi extends runtime.BaseAPI {

    /**
     * Deactivate a student without deleting their records.
     * Deactivate student
     */
    async apiStudentsIdDeactivatePutRaw(requestParameters: ApiStudentsIdDeactivatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiStudentsIdDeactivatePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/students/{id}/deactivate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deactivate a student without deleting their records.
     * Deactivate student
     */
    async apiStudentsIdDeactivatePut(requestParameters: ApiStudentsIdDeactivatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiStudentsIdDeactivatePutRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a student by its unique identifier
     * Delete student by Id
     */
    async apiStudentsIdDeleteRaw(requestParameters: ApiStudentsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiStudentsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/students/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a student by its unique identifier
     * Delete student by Id
     */
    async apiStudentsIdDelete(requestParameters: ApiStudentsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiStudentsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Create student
     */
    async apiStudentsPostRaw(requestParameters: ApiStudentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateStudentResponse>> {
        if (requestParameters['createStudentRequest'] == null) {
            throw new runtime.RequiredError(
                'createStudentRequest',
                'Required parameter "createStudentRequest" was null or undefined when calling apiStudentsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/students`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateStudentRequestToJSON(requestParameters['createStudentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateStudentResponseFromJSON(jsonValue));
    }

    /**
     * Create student
     */
    async apiStudentsPost(requestParameters: ApiStudentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateStudentResponse> {
        const response = await this.apiStudentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update student
     */
    async apiStudentsPutRaw(requestParameters: ApiStudentsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateStudentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateStudentRequest',
                'Required parameter "updateStudentRequest" was null or undefined when calling apiStudentsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/students`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStudentRequestToJSON(requestParameters['updateStudentRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update student
     */
    async apiStudentsPut(requestParameters: ApiStudentsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiStudentsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get all students
     */
    async apiStudentsScrollGetRaw(requestParameters: ApiStudentsScrollGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetStudentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/students/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetStudentResponseFromJSON(jsonValue));
    }

    /**
     * Get all students
     */
    async apiStudentsScrollGet(requestParameters: ApiStudentsScrollGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetStudentResponse> {
        const response = await this.apiStudentsScrollGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search students
     */
    async apiStudentsSearchPostRaw(requestParameters: ApiStudentsSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetStudentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/students/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchQueryRequestToJSON(requestParameters['searchQueryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetStudentResponseFromJSON(jsonValue));
    }

    /**
     * Search students
     */
    async apiStudentsSearchPost(requestParameters: ApiStudentsSearchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetStudentResponse> {
        const response = await this.apiStudentsSearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get student
     */
    async getStudentByIdRaw(requestParameters: GetStudentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStudentResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getStudentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/students/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentResponseFromJSON(jsonValue));
    }

    /**
     * Get student
     */
    async getStudentById(requestParameters: GetStudentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStudentResponse> {
        const response = await this.getStudentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
